import { useStore } from 'effector-react'
import { useCallback, useRef } from 'react'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { updateEmail, updateEmailFx } from '../model'
import { Form, updateEmailModel } from '../UpdateEmailDrawer/Form'
import { Title } from '../UpdateEmailDrawer/styled'
import { $isAddEmailDrawerOpen, closeAddEmailDrawer } from './model'

export function AddEmailDrawer() {
  const isShow = useStore($isAddEmailDrawerOpen)
  const isSubmitting = useStore(updateEmailFx.pending)
  const canDismissRef = useRef(false)
  const canDismiss = useCallback(
    () => Promise.resolve(canDismissRef.current),
    [],
  )

  const handleEmailUpdate = (formValues: updateEmailModel.FormValues) => {
    updateEmail({
      ...formValues,
      successFn: () => {
        canDismissRef.current = true
        closeAddEmailDrawer()
      },
    })
  }

  return (
    <DrawerComponent isShow={isShow} canDismiss={canDismiss}>
      <Title>Необходимо добавить почту</Title>
      <Form
        defaultValues={{}}
        onSuccess={handleEmailUpdate}
        isSubmitting={isSubmitting}
      />
    </DrawerComponent>
  )
}
